export default __webpack_public_path__ + "static/media/wecode.e4ba15be.png";